'use strict';
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

const _WarningOutlined = _interopRequireDefault(require('./lib/icons/WarningOutlined'));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

const _default = _WarningOutlined;
exports.default = _default;
module.exports = _default;